<template>
  <div
    :class="jel_getClassObject(content)"
    class="d-flex justify-content-around justify-content-md-start py-2"
  >
    <b-link :disabled="$i18n.locale == 'fr'" class="pr-md-4" :href="urlAutreLangue"
      >Français</b-link
    >
    <b-link :disabled="$i18n.locale == 'en'" class="pl-md-4" :href="urlAutreLangue">English</b-link>
  </div>
</template>

<script>
import { bus } from '@/main';

export default {
  name: 'ChangerLangue',
  props: { content: { type: Object, required: true } },
  data() {
    return {
      urlAutreLangue: '',
    };
  },
  mounted() {
    bus.$on('urlAutreLangue', (url) => {
      this.urlAutreLangue = url;
    });
  },
};
</script>

<style lang="scss" scoped>
div a {
  color: $couleur-primaire-bouton-theme-clair;
  font-family: graphik_medium;
  font-size: 0.9rem;
  &.disabled {
    opacity: 50%;
    color: rgba(11, 94, 183, 0.8);
    font-family: graphik_regular;
  }
}
</style>
